module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("HtKqv"))).then(() => parcelRequire('01Tl8'));